import { Pipe, PipeTransform } from '@angular/core';
import { CompanyProductUserMember } from 'src/app/models/company_product_user_member.model';
import { CompanyProductUserMemberRole } from 'src/app/models/company_product_user_member_role.model';

@Pipe({ name: 'companyProductRoleMembersLabel' })
export class CompanyProductRoleMembersLabelPipe implements PipeTransform {
  transform(members: CompanyProductUserMember[] | null | undefined, role_slug: CompanyProductUserMemberRole['slug']): string {
    const matching_members = (members ?? []).filter(member => member.company_product_user_member_role?.slug === role_slug);

    if (matching_members.length === 0) {
      return '-';
    }

    return matching_members.map(member => `${member.user.name} ${member.user.surnames}`.trim()).join(', ');
  }
}
